import React from 'react'
import { SvgIcon } from '@mui/material'

export const PlusRoundedIcon = props => (
  <SvgIcon
    viewBox="0 0 34 34"
    sx={{ color: 'white', width: '34px', height: '34px' }}
    {...props}
  >
    <path
      d="M17 2.84a14.17 14.17 0 1 1 0 28.33 14.17 14.17 0 0 1 0-28.33Zm0 7.08c-.54 0-.98.4-1.05.92l-.01.14v4.96h-4.96a1.06 1.06 0 0 0-.14 2.12h5.1v4.96a1.06 1.06 0 0 0 2.12.15V18.07h4.96a1.06 1.06 0 0 0 .15-2.12l-.15-.01h-4.95v-4.96c0-.59-.48-1.06-1.07-1.06Z"
      fill="#55A6FF"
    />
  </SvgIcon>
)
